export default __webpack_public_path__ + "static/Museo-Sans-500-Italic-d8496f793f963257ac6d648d8c4f4fd1.woff2";